// @ts-nocheck
import * as Types from '../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc } from '../../fragments/commonFragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type CostSourceSelectQueryVariables = Types.Exact<{
  filter: Types.BidContractLineItemFilter;
}>;


export type CostSourceSelectQuery = { __typename?: 'Query', bidContractLineItems: Array<{ __typename?: 'BidContractLineItem', unitCostInCents: number, id: string, name: string, bidItem?: { __typename?: 'BidItem', id: string } | null | undefined }> };

export type CostSourceSelect_BidContractLineItemFragment = { __typename?: 'BidContractLineItem', unitCostInCents: number, id: string, name: string, bidItem?: { __typename?: 'BidItem', id: string } | null | undefined };

export const CostSourceSelect_BidContractLineItemFragmentDoc = gql`
    fragment CostSourceSelect_BidContractLineItem on BidContractLineItem {
  ...Named
  unitCostInCents
  bidItem {
    id
  }
}
    ${NamedFragmentDoc}`;
export const CostSourceSelectDocument = gql`
    query CostSourceSelect($filter: BidContractLineItemFilter!) {
  bidContractLineItems(filter: $filter) {
    ...CostSourceSelect_BidContractLineItem
  }
}
    ${CostSourceSelect_BidContractLineItemFragmentDoc}`;

/**
 * __useCostSourceSelectQuery__
 *
 * To run a query within a React component, call `useCostSourceSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useCostSourceSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCostSourceSelectQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCostSourceSelectQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CostSourceSelectQuery, CostSourceSelectQueryVariables> & ({ variables: CostSourceSelectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CostSourceSelectQuery, CostSourceSelectQueryVariables>(CostSourceSelectDocument, options);
      }
export function useCostSourceSelectLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CostSourceSelectQuery, CostSourceSelectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CostSourceSelectQuery, CostSourceSelectQueryVariables>(CostSourceSelectDocument, options);
        }
// @ts-ignore
export function useCostSourceSelectSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CostSourceSelectQuery, CostSourceSelectQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CostSourceSelectQuery, CostSourceSelectQueryVariables>;
export function useCostSourceSelectSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CostSourceSelectQuery, CostSourceSelectQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CostSourceSelectQuery | undefined, CostSourceSelectQueryVariables>;
export function useCostSourceSelectSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CostSourceSelectQuery, CostSourceSelectQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CostSourceSelectQuery, CostSourceSelectQueryVariables>(CostSourceSelectDocument, options);
        }
export type CostSourceSelectQueryHookResult = ReturnType<typeof useCostSourceSelectQuery>;
export type CostSourceSelectLazyQueryHookResult = ReturnType<typeof useCostSourceSelectLazyQuery>;
export type CostSourceSelectSuspenseQueryHookResult = ReturnType<typeof useCostSourceSelectSuspenseQuery>;
export type CostSourceSelectQueryResult = Apollo.QueryResult<CostSourceSelectQuery, CostSourceSelectQueryVariables>;